module.exports = __webpack_public_path__ + "img/link.f418281c.svg";